import { Fragment } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { v } from '@/theme/tokens';

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <header
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: 20,
        gap: 16,
        // A title and its actions wrap onto a second line rather than
        // widening the page: on a phone «Производство «Гераци»» and an
        // export button do not fit side by side.
        flexWrap: 'wrap',
      }}
    >
      <div style={{ minWidth: 0, flex: '1 1 auto' }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, letterSpacing: -0.4, overflowWrap: 'anywhere' }}>
          {/* Each word is its own span so the glass skin can bring the
              title in word by word (styles/glass.css, .rt-word); the text
              and the heading's accessible name are unchanged. */}
          {title.split(' ').map((word, index, words) => (
            <Fragment key={index}>
              <span className="rt-word" style={{ '--i': index } as CSSProperties}>
                {word}
              </span>
              {index < words.length - 1 ? ' ' : null}
            </Fragment>
          ))}
        </h1>
        {subtitle && (
          <div style={{ color: v('ink-muted'), fontSize: 13.5, marginTop: 4, overflowWrap: 'anywhere' }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions}
    </header>
  );
}
